import { get } from 'lodash';
import {
	UPDATE_REASON,
	GET_PAYMENT_REASON_SUCCESS,
	GET_PAYMENT_REASON_FAILURE,
	CREATE_OUTCOME_SUCCESS,
	CREATE_OUTCOME_FAILURE,
	RETRIEVE_OUTCOME_SUCCESS,
	RETRIEVE_OUTCOME_FAILURE,
	SET_DECLARATION_STATUS,
	SET_UI_ERROR,
	RESET_EFFECTIVE_WARNING,
	SET_CURRENT_WARNING_PAGE,
	GENERATE_RETRIEVAL_ID_SUCCESS,
	GENERATE_RETRIEVAL_ID_FAILURE,
	GENERATE_RETRIEVAL_ID_REQUEST,
	UPDATE_OUTCOME_ACK_REQUEST,
	RETRIEVE_OUTCOME_REQUEST,
	CREATE_OUTCOME_REQUEST,
	GET_PAYMENT_REASON_REQUEST,
	SET_ACCOUNT_DETAILS_PAYEE_ID,
	RESET_APP,
} from './actions';

import { ACK_PAGE } from '../utils/constants';

export const initialState = {
	reasonId: '',
	paymentReasons: undefined,
	declarationValue: false,
	ewOutcome: null,
	reviewData: null,
	uiError: false,
	approverData: null,
	currentWarningPage: ACK_PAGE,
	isApprovalJourney: false,
};

const actionHandlers = {
	[UPDATE_REASON]: (state, action) => ({
		...state,
		reasonId: action.id,
		reviewData: { ...state.reviewData, effectiveWarningReason: action.reason },
	}),
	[GET_PAYMENT_REASON_SUCCESS]: (state, action) => ({ ...state, paymentReasons: action.payload.payment_reasons }),
	[GET_PAYMENT_REASON_FAILURE]: (state) => ({ ...state, apiError: true }),
	[CREATE_OUTCOME_SUCCESS]: (state, action) => ({ ...state, ewOutcome: action.payload }),
	[CREATE_OUTCOME_FAILURE]: (state) => ({ ...state, apiError: true }),
	[RETRIEVE_OUTCOME_SUCCESS]: (state, action) => ({ ...state, retrievedOutcome: action.payload.effective_warning }),
	[RETRIEVE_OUTCOME_FAILURE]: (state) => ({ ...state, apiError: true, retrievedOutcome: {} }),
	[SET_DECLARATION_STATUS]: (state, { declarationValue }) => ({ ...state, declarationValue, uiError: false }),
	[SET_UI_ERROR]: (state, action) => ({ ...state, uiError: action.uiError }),
	[RESET_EFFECTIVE_WARNING]: () => initialState,
	[SET_CURRENT_WARNING_PAGE]: (state, action) => ({ ...state, currentWarningPage: action.currentPage }),
	[GENERATE_RETRIEVAL_ID_SUCCESS]: (state, action) => ({
		...state,
		retrievalId: action.payload.effective_warning_retrieval_id,
	}),
	[GENERATE_RETRIEVAL_ID_FAILURE]: (state) => ({ ...state, apiError: true }),
	[SET_ACCOUNT_DETAILS_PAYEE_ID]: (state, action) => ({
		...state,
		accountDetails: { ...state.accountDetails, payee: { ...state.accountDetails.payee, id: action.payload } },
	}),
	[RESET_APP]: () => initialState,
};

const requestActions = [
	GENERATE_RETRIEVAL_ID_REQUEST,
	UPDATE_OUTCOME_ACK_REQUEST,
	RETRIEVE_OUTCOME_REQUEST,
	CREATE_OUTCOME_REQUEST,
	GET_PAYMENT_REASON_REQUEST,
];

const effectiveWarning = (state = initialState, action) => {
	if (requestActions.includes(action.type) && get(action, 'error', false)) {
		return { ...state, apiError: true };
	}
	return (actionHandlers[action.type] || ((s) => s))(state, action);
};

export default effectiveWarning;
